module.exports = __webpack_public_path__ + "static/media/female.497f389b.svg";